import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,
  Tooltip as TooltopStrap,
  Toast,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Chart, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import UseChartData from "data/dataSet";
/* import UseChartData2 from "data/dataSet2"; */
import CustomRadarController from "components/CustomRadarController";
import CustomRadialLinearScale from "components/CustomRadialLinearScale";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useReactToPrint } from "react-to-print";
const logo = require("../assets/sphera.png");
const share = require("../assets/share.png");
const imprim = require("../assets/imprim.png");
import "./Dashboard.css";
import ActivityTimeline from "./ActivityTimeline";

ChartJS.register(LineElement, PointElement, Filler, Tooltip, Legend);
ChartJS.register(CustomRadarController, CustomRadialLinearScale);

export function formatFirestoreDate(createdAt) {
  // Convertir le timestamp Firestore en millisecondes
  const date = new Date(
    createdAt.seconds * 1000 + createdAt.nanoseconds / 1000000
  );

  // Formater la date en DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Les mois commencent à 0
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatISODate(dateString) {
  // Convertir la chaîne de caractères en un objet Date
  const date = new Date(dateString);

  // Formater la date en DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Les mois commencent à 0
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatName(firstName, lastName) {
  // Capitaliser la première lettre du prénom et du nom
  const formattedLastName =
    lastName.charAt(0)?.toUpperCase() + lastName.slice(1).toLowerCase();
  const formattedFirstNameInitial = firstName.charAt(0)?.toUpperCase();

  // Combiner les deux pour obtenir le format souhaité
  return `${formattedLastName}.${formattedFirstNameInitial}`;
}

const RadarLabel = ({ top, left, right, bottom, labelText, colorText }) => (
  <div
    style={{
      position: "absolute",
      top: top,
      left: left,
      right: right,
      bottom: bottom,
      fontWeight: "bold",
      fontSize: "14px",
      padding: "4px",
      borderRadius: "4px",
      whiteSpace: "nowrap",
      textAlign: "center",
      color: colorText ?? "#000",
    }}>
    {labelText}
  </div>
);

const DashboardForward = React.forwardRef((props, ref) => {
  const {
    handlePrint,
    isPrinting, // Ajoutez cette prop
  } = props;

  const chartRef = useRef();
  /*  const { chartData2 } = UseChartData2(); */
  const location = useLocation();
  const [userInfos, setUserInfos] = useState(null);
  const [loadingUser, setLoadingUser] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  const [shared, setShared] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTestId, setSelectedTestId] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [shareInfos, setShareInfos] = useState(null);
  const [unlocked, setUnlocked] = useState(false);
  const [shareType, setShareType] = useState(null);
  const [shareOwnerInfo, setShareOwnerInfo] = useState(null);
  const {
    chartData,
    loading,
    testData,
    setDate,
    setDate2,
    testDates,
    fetchData,
    testInfos,
    date2
  } = UseChartData();
  const role = localStorage.getItem("role");
  const userIdStorage = localStorage.getItem("userIdStorage");
  const [requestSentDate, setRequestSentDate] = useState(null);
  const [requestData, setRequestData] = useState(null);
  const [referentInfos, setReferentInfos] = useState(null);
  const [requestSentTestId, setRequestSentTestId] = useState(null);

  const [currentShareData, setCurrentShareData] = useState(null);
  const [currentCandidateShareData, setCurrentCandidateShareData] =
    useState(null);

  const ownerFirstname = localStorage.getItem("firstName");
  const ownerLastname = localStorage.getItem("lastName");
  const ownerRole = localStorage.getItem("role");

  const activities = useMemo(
    () => {
      if (!!!userInfos) return [];
      return [
        {
          icon: "share",
          text: `Résultats partagés à ${formatName(
            userInfos?.lastName,
            userInfos?.firstName
          )}`,
          date: testData?.[0]?.sharedDate
            ? formatFirestoreDate(testData?.[0]?.sharedDate)
            : "-",
        },
        {
          icon: "check",
          text: `${formatName(
            userInfos?.lastName,
            userInfos?.firstName
          )} a terminé le test`,
          date: !selectedDate ? "-" : formatISODate(selectedDate),
        },
        {
          icon: "calendar",
          text: `Création du compte ${formatName(
            userInfos?.lastName,
            userInfos?.firstName
          )}`,
          date: formatISODate(userInfos?.createdAt),
        },
      ];
    },
    [userInfos, testData?.[0]],
    shared
  );

  const fetchUser = async (idUser) => {
    setLoadingUser(true);
    try {
      const userDoc = await getDoc(doc(db, "users", idUser));
      if (userDoc.exists()) {
        const userData = { id: userDoc.id, ...userDoc.data() };
        setUserInfos(userData);
      } else {
        console.error("No such user!");
      }
    } catch (error) {
      console.error("Error fetching users: ", error);
    } finally {
      setLoadingUser(false);
    }
  };

  useEffect(() => {
    setShared(testData?.[0]?.sharedState);
    setShareType(testData?.[0]?.shareType);
    setShareOwnerInfo(testData?.[0]?.shareOwnerInfo);
  }, [testData?.[0]?.sharedState, testData?.[0]?.shareType, testInfos]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idUser = params.get("userId");
    console.log("idUser", idUser);
    if (idUser) {
      fetchUser(idUser);
    }
  }, [location]);

  useEffect(() => {
    if (testData?.length > 0 && !selectedDate) {
      setSelectedDate(testData[0]?.testDate);
      setSelectedTestId(testData[0]?.testId);
      handleCheckTestIsAlreadyShared(testData[0]?.testDate);
      setDate(testData[0]?.testDate);
    }
  }, [testData]);

  const handleDateChange = async (e) => {
    const date = e.target.value;
    const testId = testInfos.find((test) => test.date === date).testId;
    setSelectedDate(date);
    setSelectedTestId(testId);
    setDate(date);
    handleCheckTestIsAlreadyShared(date);
  };

  const handleCheckTestIsAlreadyShared = async (newDate: string) => {
    const formattedDate = new Date(newDate).toISOString();

    try {
      const testCollection = collection(db, "UserTests");
      // Requête pour vérifier la date et l'état de partage
      const q = query(
        testCollection,
        where("testDate", "==", formattedDate),
        where("sharedState", "==", false) // Assurez-vous que `sharedState` est le champ correct pour l'état de partage
      );
      const querySnapshot = await getDocs(q);
      let string = `Partager les résultats du questionnaire du ${formatISODate(
        newDate
      )}`;
      if (!querySnapshot.empty) {
        return setShareInfos(string);
      }
      setShareInfos(string);
    } catch (error) {
      console.error("Error checking tests:", error);
    }
  };

  const filteredTestData = testData?.filter(
    (test) => test.testId === selectedTestId
  );

  const hasSharedWithCandidate =
    filteredTestData?.[0]?.shareData?.filter(
      (share) => share.ownerInfo?.role === ownerRole
    ).length > 0;

  const createLabelFunction = (data) => {
    return function (context) {
      let label = "";
      const dataIndex = context?.dataIndex;
      label += context?.raw + " : ";

      // Accéder aux questions depuis data.datasets[0].questions
      const questions = data?.datasets?.[0]?.questions;
      if (Array.isArray(questions) && questions.length > dataIndex) {
        // Utiliser directement l'index pour accéder à la question
        label += questions[dataIndex];
      } else {
        label += "Données non disponibles";
      }

      return label;
    };
  };

  const options = {
    scales: {
      r: {
        beginAtZero: true,
        min: 0,
        max: 9,
        type: "derivedRadialLinearScale",
        ticks: {
          display: false,
        },
        angleLines: {
          display: true,
          borderDashOffset: 5,
          lineWidth: 1,
        },
        elements: {
          line: {
            borderWidth: 3,
          },
        },
        gridLines: {
          color: ["red", "orange"],
        },
        pointLabels: {
          padding: 10,
          font: {
            size: 10,
            weight: "600",
          },
          color: "#37474f",
          backdropPadding: 2,
          borderRadius: 4,
        },
      },
    },
    elements: {
      line: {
        borderWidth: 10,
        borderJoinStyle: "round",
        borderCapStyle: "round",
      },
      point: {
        pointStyle: "circle",
        borderColor: "rgba(255,255,255,0.1)",
      },
    },
    responsive: true,
    layout: {
      padding: {
        left: -10, // Décaler la légende vers la gauche en créant de l'espace négatif
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "left",
        align: "start",
        labels: {
          padding: 20, // Ajoute un padding de 20 pixels autour des éléments de la légende
          usePointStyle: true, // Utiliser les styles de point dans la légende
        },
      },
      area: {
        backgroundColor: "rgba(255, 0, 0, 0.1)",
      },
      tooltip: {
        callbacks: {
          label: createLabelFunction(chartData || []),
        },
        titleFont: {
          size: 16,
        },
        bodyFont: {
          size: 16,
        },
      },
    },
  };

  /*  const fetchExistingRequest = async (userId) => {
    try {
      console.log("userId:", userId);
      console.log("selectedTestId:", selectedTestId);

      const userReferentQuery = query(
        collection(db, "UserReferent"),
        where("userId", "==", userId),
        where("testId", "==", selectedTestId)
      );
      const querySnapshot = await getDocs(userReferentQuery);

      if (!querySnapshot.empty) {
        const requestData = querySnapshot.docs[0].data();
        console.log("requestData", requestData);
        setRequestSentDate(requestData.requestDate.toDate());
        console.log("requestData", requestData);
        setRequestSentTestId(requestData.testId);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de la demande:", error);
    }
  };

  useEffect(() => {
    if (userInfos?.id) {
      fetchExistingRequest(userInfos.id);
    }
  }, [userInfos]); */

  /* Vérifier si il y a une demande de déblocage en cours fait par le référent pour un test donné */
  const [infoRequestUser, setInfoRequestUser] = useState(null);
  const checkIfRequestIsAlreadySentByReferent = async (userId) => {
    try {
      const userReferentQuery = query(
        collection(db, "UserReferent"),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(userReferentQuery);

      if (!querySnapshot.empty) {
        const requestData = querySnapshot.docs[0].data();
        console.log("requestData", requestData);
        setRequestSentDate(requestData.requestDate.toDate());
        setRequestSentTestId(requestData.testId);

        //get infor referent with requestData.referentId
        const referentDoc = await getDoc(
          doc(db, "users", requestData.referentId)
        );
        if (referentDoc.exists()) {
          const referentData = { id: referentDoc.id, ...referentDoc.data() };
          setInfoRequestUser({
            requestDate: requestData.requestDate,
            referentName: referentData.firstName + " " + referentData.lastName,
          });
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de la demande:", error);
    }
  };

  useEffect(() => {
    if (userInfos?.id) {
      checkIfRequestIsAlreadySentByReferent(userInfos.id);
    }
  }, [userInfos, selectedTestId]);

  const handleShare = async (shareType) => {
    if (!testData || testData.length === 0) {
      setToastVariant("danger");
      setToastMessage("Aucun test disponible à partager");
      setShowToast(true);
      return;
    }

    const testId = testData[0].id;
    try {
      const docRef = doc(db, "UserTests", testId);
      const currentDoc = await getDoc(docRef);
      const currentShareTypes = currentDoc.data()?.shareTypes || [];

      // Si le nouveau shareType est différent, supprimer l'ancien et ajouter le nouveau
      const updatedShareTypes = currentShareTypes.some(
        (type) => type !== shareType
      )
        ? [shareType] // Remplacer l'ancien type par le nouveau
        : currentShareTypes.includes(shareType)
          ? currentShareTypes.filter((type) => type !== shareType) // Retirer le type s'il existe déjà
          : [...currentShareTypes, shareType]; // Ajouter le nouveau type s'il n'existe pas

      // Créer le nouvel objet de partage
      const newShareInfo = {
        shareType,
        referentId:
          shareType === "referent" ? userInfos.referentId || null : null,
        ownerInfo: {
          firstName: ownerFirstname,
          lastName: ownerLastname,
          userId: userIdStorage,
          role: ownerRole,
        },
      };

      await updateDoc(docRef, {
        sharedState: updatedShareTypes.length > 0,
        sharedDate: updatedShareTypes.length > 0 ? serverTimestamp() : null,
        shareData: [newShareInfo],
        shareTypes: updatedShareTypes,
      });

      // Mettre à jour l'état local
      const currentDate = new Date();
      setShared(updatedShareTypes.length > 0);
      setShareType(updatedShareTypes);
      setCurrentShareData(
        `${shareType === "referent" ? "référent" : "client"
        } le ${currentDate.toLocaleDateString()}`
      );

      setToastVariant("success");
      setToastMessage(
        `Les résultats ont été ${updatedShareTypes.includes(shareType) ? "partagés avec" : "retirés du"
        } ${shareType === "referent" ? "référent" : "client"
        } le ${currentDate.toLocaleDateString()}`
      );
      setShowToast(true);
    } catch (error) {
      console.error("Error updating document: ", error);
      setToastVariant("danger");
      setToastMessage("Une erreur est survenue lors du partage");
      setShowToast(true);
    }
  };

  const handleSendTest = async () => {
    try {
      if (ownerRole === "admin") {
        if (!!userInfos?.newTestSended) {
          const confirmUpdate = window.confirm(
            "Un test a déjà été envoyé. En cliquant sur 'Oui', cela modifiera la date d'envoi du test précédent. Voulez-vous continuer ?"
          );
          if (!confirmUpdate) {
            return;
          }
        }


        const currentDate = new Date().toISOString();
        const userRef = doc(db, "users", userInfos.id);
        await updateDoc(userRef, {
          newTestSended: currentDate,
        });

        // Mettre à jour l'état local userInfos avec la nouvelle date
        setUserInfos((prevState) => ({
          ...prevState,
          newTestSended: currentDate,
        }));

        //Ici vérifier si dans la collection UserReferent
        //on a un doc avec le userId userInfos.id si oui on supprime le doc

        const userReferentQuery = query(
          collection(db, "UserReferent"),
          where("userId", "==", userInfos.id)
        );
        const querySnapshot = await getDocs(userReferentQuery);
        if (!querySnapshot.empty) {
          setInfoRequestUser(null);
          // Récupérer l'ID du premier document trouvé
          const docId = querySnapshot.docs[0].id;
          // Utiliser cet ID pour la suppression
          const docRef = doc(db, "UserReferent", docId);
          await deleteDoc(docRef);
        }

        setToastVariant("success");
        setToastMessage("Le test a bien été mis à jour et envoyé.");
        setShowToast(true);
      }

      if (ownerRole === "referent") {
        /* return console.log({
          userId: userInfos.id,
          testId: selectedTestId,
          referentId: userIdStorage,
          requestDate: serverTimestamp(),
          status: "pending",
        }) */
        const userReferentRef = doc(collection(db, "UserReferent"));
        await setDoc(userReferentRef, {
          userId: userInfos.id,
          testId: selectedTestId,
          referentId: userIdStorage,
          requestDate: serverTimestamp(),
          status: "pending",
        });

        const currentDate = new Date();
        setRequestSentDate(currentDate);
        setRequestSentTestId(selectedTestId);
        setToastVariant("success");
        setToastMessage(
          "Votre demande de déblocage a été envoyée à l'administrateur."
        );
        setShowToast(true);
      }
    } catch (error) {
      console.error("Erreur lors de la demande:", error);
      setToastVariant("danger");
      setToastMessage("Une erreur est survenue lors de la demande.");
      setShowToast(true);
    }
  };

  const handleShareByReferent = async () => {
    if (!testData || testData.length === 0) {
      setToastVariant("danger");
      setToastMessage("Aucun test disponible à partager");
      setShowToast(true);
      return;
    }

    const testId = selectedTestId;

    try {
      const docRef = doc(db, "UserTests", testId);
      const currentDoc = await getDoc(docRef);
      const currentData = currentDoc.data();
      const currentShareTypes = currentData?.shareTypes || [];
      const currentShareData = currentData?.shareData || [];

      // Vérifier si le type "candidate" existe déjà
      const hasCandidate = currentShareTypes.includes("candidate");

      // Supprimer les partages existants avec le même shareType
      const updatedShareData = currentShareData.filter(
        (share) => share.shareType !== "candidate"
      );

      // Si le type "candidate" existe déjà, on le retire
      // Sinon, on l'ajoute
      const updatedShareTypes = hasCandidate
        ? currentShareTypes.filter((type) => type !== "candidate")
        : [...currentShareTypes, "candidate"];

      // Ajouter la nouvelle entrée shareData seulement si on ajoute le type
      if (!hasCandidate) {
        const newShareInfo = {
          shareType: "candidate",
          ownerInfo: {
            firstName: ownerFirstname,
            lastName: ownerLastname,
            userId: userIdStorage,
            role: ownerRole,
          },
        };
        updatedShareData.push(newShareInfo);
      }

      await updateDoc(docRef, {
        sharedState: updatedShareTypes.length > 0,
        sharedDate: updatedShareTypes.length > 0 ? serverTimestamp() : null,
        shareData: updatedShareData,
        shareTypes: updatedShareTypes,
      });

      // Mettre à jour l'état local
      setCurrentCandidateShareData(
        hasCandidate
          ? "Partager les résultats avec le client"
          : "Les résultats ont été partagés avec le client"
      );

      setToastVariant("success");
      setToastMessage(
        hasCandidate
          ? "Les résultats ont été retirés du client"
          : "Les résultats ont été partagés avec le client"
      );
      setShowToast(true);
    } catch (error) {
      console.error("Error updating document: ", error);
      setToastVariant("danger");
      setToastMessage("Une erreur est survenue lors du partage");
      setShowToast(true);
    }
  };

  const fetchReferentInfos = async (referentId) => {
    try {
      const referentDoc = await getDoc(doc(db, "users", referentId));
      if (referentDoc.exists()) {
        const referentData = { id: referentDoc.id, ...referentDoc.data() };
        setReferentInfos(referentData);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du référent:", error);
    }
  };

  useEffect(() => {
    if (userInfos?.referentId) {
      fetchReferentInfos(userInfos.referentId);
    }
  }, [userInfos?.referentId]);

  const fetchFilteredTestData = async (testId) => {
    if (!testId) return [];

    try {
      // Récupérer directement le document avec son ID
      const testDoc = await getDoc(doc(db, "UserTests", testId));

      if (testDoc.exists()) {
        return [
          {
            id: testDoc.id,
            ...testDoc.data(),
          },
        ];
      }
      return [];
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données de test:",
        error
      );
      return [];
    }
  };

  const [hasSharedWithReferent, setHasSharedWithReferent] = useState(false);

  useEffect(() => {
    const getFilteredTestData = async () => {
      if (!selectedTestId) return;

      try {
        const data = await fetchFilteredTestData(selectedTestId);

        if (data?.[0]) {
          const hasSharedWithCandidate =
            data[0].shareData?.filter(
              (share) => share?.shareType === "candidate"
            ).length > 0;

          const hasSharedWithReferent =
            data[0].shareData?.filter(
              (share) => share?.shareType === "referent"
            ).length > 0;

          setHasSharedWithReferent(hasSharedWithReferent);

          if (!hasSharedWithCandidate) {
            setCurrentCandidateShareData(
              `Partager les résultats avec le client`
            );
          }
          if (hasSharedWithCandidate && data[0].sharedDate) {
            setCurrentCandidateShareData(
              `Résultats partagés avec le client le ${formatFirestoreDate(
                data[0].sharedDate
              )}`
            );
          }
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
    };

    getFilteredTestData();
  }, [testData, selectedTestId, ownerRole]);

  const [showPeriod2, setShowPeriod2] = useState(false);

  /*   if (loading || loadingUser) {
    return (
      <Container
        fluid
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <span>Chargement...</span>
      </Container>
    );
  } */
  return (
    <div className="print-container" ref={ref}>
      <Container fluid>
        {role === "admin" && (
          <div
            style={{
              display: "flex",
              borderRadius: 8,
              padding: 6,
              backgroundColor:
                unlocked || userInfos?.newTestSended ? "#4CAF50" : "#f07167",
              marginBottom: 30,
              alignSelf: "flex-start",
            }}>
            <text style={{ color: "#fff", fontSize: 14 }}>
              {unlocked || userInfos?.newTestSended
                ? `Questionnaire débloqué le ${formatISODate(
                  unlocked
                    ? new Date().toISOString()
                    : userInfos?.newTestSended
                )}`
                : "Questionnaire non débloqué"}
            </text>
          </div>
        )}
        {/* Affichage des demandes en attentes de déblocage */}
        {role === "admin" && !!infoRequestUser && (
          <Col md={12}>
            <div
              style={{
                padding: "15px 20px",
                marginTop: "15px",
                marginBottom: "25px",
                backgroundColor: "#FFF8E7",
                borderRadius: "10px",
                border: "2px solid #CE9136",
                fontFamily: "Montserrat",
                boxShadow: "0 2px 4px rgba(206, 145, 54, 0.1)",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}>
              <i
                className="fas fa-info-circle"
                style={{ color: "#CE9136", fontSize: "20px" }}
              />
              <p style={{ margin: 0, color: "#666" }}>
                <strong style={{ color: "#CE9136" }}>
                  Demande en attente :{" "}
                </strong>
                Le référent {infoRequestUser?.referentName || "Inconnu"} a
                demandé le déblocage du questionnaire pour ce candidat le{" "}
                {formatFirestoreDate(infoRequestUser?.requestDate)}
              </p>
            </div>
          </Col>
        )}
        {/* Affichage du bouton des résultats partagés */}
        {role === "admin" &&
          testData?.[0]?.shareData?.some(
            (share) =>
              share.shareType === "candidate" &&
              share.ownerInfo?.role === "referent"
          ) && (
            <Col md={12}>
              <div
                style={{
                  padding: "15px 20px",
                  marginTop: "15px",
                  marginBottom: "25px",
                  backgroundColor: "#F0F9F1",
                  borderRadius: "10px",
                  border: "2px solid #4CAF50",
                  fontFamily: "Montserrat",
                  boxShadow: "0 2px 4px rgba(74, 175, 80, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}>
                <i
                  className="fas fa-info-circle"
                  style={{ color: "#4CAF50", fontSize: "20px" }}
                />
                <p style={{ margin: 0, color: "#666" }}>
                  <strong style={{ color: "#4CAF50" }}>
                    Résultats partagés :{" "}
                  </strong>
                  Le référent{" "}
                  {testData[0].shareData.find(
                    (share) =>
                      share.shareType === "candidate" &&
                      share.ownerInfo?.role === "referent"
                  )?.ownerInfo?.firstName || ""}{" "}
                  {testData[0].shareData.find(
                    (share) =>
                      share.shareType === "candidate" &&
                      share.ownerInfo?.role === "referent"
                  )?.ownerInfo?.lastName || ""}{" "}
                  a partagé les résultats avec le client le{" "}
                  {formatFirestoreDate(testData[0].sharedDate)}
                </p>
              </div>
            </Col>
          )}
        <Col
          md={12}
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 30,
          }}>
          <img
            src={logo}
            alt="Insights"
            className="img-fluid"
            style={{ height: "100px" }}
          />
          <div style={{ flex: 1 }}>
            <h1 className="title">
              {userInfos?.firstName} {userInfos?.lastName}
            </h1>
            <span className="subtitle">Sphère représentant vos résultats</span>
          </div>
       
          {/* Bouton de partage du questionnaire avec le referent ou l'utilisateur */}
          {role === "admin" && shareInfos && (
            <div style={{ display: "flex", gap: 10 }}>
              <Dropdown style={{ width: "100%" }}>
                <Dropdown.Toggle
                  variant="secondary"
                  style={{
                    borderRadius: 15,
                    backgroundColor:shared ? "#4CAF50": "#CE9136",
                    borderColor: shared ? "#4CAF50":"#CE9136",
                    color: "#ffffff",
                    width: "100%",
                  }}>                
                  {!shared ? (
                    shareInfos
                  ) : (
                    <span>
                      {currentShareData  ? (
                        `Résultats partagés avec ${currentShareData}`
                      ) : (
                        <>
                          {! Boolean(testData?.[0]?.shareData
                              ?.filter(
                                (share) =>
                                  share.ownerInfo?.userId === userIdStorage
                              )?.find(item=> item.shareType)) ? shareInfos : Array.isArray(testData?.[0]?.shareData) &&
                              testData[0].shareData
                                .filter(
                                  (share) =>
                                    share.ownerInfo?.userId === userIdStorage
                                )
                                .map((share, index) => (
                                  <span key={index}>
                                    Résultats partagés avec{' '}
                                    {share.shareType === "referent"
                                      ? "le référent"
                                      : "le client"}
                                    {testData?.[0]?.sharedDate
                                      ? ` le ${formatFirestoreDate(
                                        testData[0].sharedDate
                                      )}`
                                      : ` le ${new Date().toLocaleDateString(
                                        "fr-FR"
                                      )}`}
                                  </span>
                                )) }
               
                        </>
                      )}
                    </span>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ width: "100%" }}>
                  {userInfos?.referentId && (
                    <Dropdown.Item
                      onClick={() => handleShare("referent")}
                      style={{ width: "100%" }}>
                      Référent
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => handleShare("candidate")}
                    style={{ width: "100%" }}>
                    Client
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>            
            </div>
          )}
          
          {/* Button de déblocage de questionnaire */}
          {role === "admin" && (
            <Button
              variant="secondary"
              onClick={handleSendTest}
              style={{
                borderRadius: 15,
                borderColor: "#ce9136",
                color: "#ce9136",
                fontFamily: "Montserrat",
              }}>
              {userInfos?.newTestSended
                ? `Questionnaire débloqué le ${unlocked
                  ? formatISODate(new Date())
                  : formatISODate(userInfos?.newTestSended)
                }`
                : "Débloquer un nouveau questionnaire"}
            </Button>
          )}
          {role === "referent" && (
            <>
              {userInfos?.newTestSended ? (
                <div
                  style={{
                    padding: "10px 15px",
                    backgroundColor: "#F0F9F1",
                    borderRadius: "10px",
                    border: "2px solid #4CAF50",
                    color: "#4CAF50",
                  }}>
                  <i
                    className="fas fa-check-circle"
                    style={{ marginRight: "8px" }}
                  />
                  Questionnaire débloqué le{" "}
                  {formatISODate(userInfos.newTestSended)}
                </div>
              ) : requestSentDate && selectedTestId === requestSentTestId ? (
                <div
                  style={{
                    padding: "10px 15px",
                    backgroundColor: "#FFF8E7",
                    borderRadius: "10px",
                    border: "1px solid #CE9136",
                    color: "#666",
                  }}>
                  <i
                    className="fas fa-info-circle"
                    style={{ color: "#CE9136", marginRight: "8px" }}
                  />
                  Déblocage demandé le {formatISODate(requestSentDate)}
                </div>
              ) : (
                <Button
                  variant="secondary"
                  onClick={handleSendTest}
                  style={{
                    borderRadius: 15,
                    borderColor: "#ce9136",
                    color: "#ce9136",
                    fontFamily: "Montserrat",
                  }}>
                  {chartData
                    ? "Demandez à l'administrateur le déblocage d'un nouveau questionnaire"
                    : "Demander le déblocage du questionnaire"}
                </Button>
              )}
            </>
          )}
          {role === "referent" && (
            <Button
              onClick={handleShareByReferent}
              variant="secondary"
              disabled={!hasSharedWithReferent}
              style={{
                borderRadius: 15,
                backgroundColor:
                  !testData || testData.length === 0 ? "#cccccc" : "#CE9136",
                borderColor:
                  !testData || testData.length === 0 ? "#cccccc" : "#CE9136",
                color: "#ffffff",
                cursor:
                  !testData || testData.length === 0
                    ? "not-allowed"
                    : "pointer",
              }}>
              {currentCandidateShareData ||
                "Partager les résultats avec le client"}
            </Button>
          )}
              <Button
            onClick={handlePrint}
            variant="secondary"
            style={{
              borderRadius: 15,
              borderColor: "#CE9136",
              color: "#CE9136",
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginLeft: "auto"
            }}>
            <img src={imprim} alt="Imprimer" style={{ height: 20 }} />
          </Button> 
        </Col>

        <Row style={{margin: 0}}>
          {testDates?.length > 0 && (
            <Row style={{gap:10,}} >
              <Col md={4} style={{ marginBottom: 20 }}>
                <Form.Label style={{ color: "#ce9136" }}>Date du questionnaire</Form.Label>
                <Form.Select
                  style={{
                    height: 42,
                    borderColor: "#ce9136",
                    color: "#ce9136",
                    borderWidth: 2,
                    borderRadius: 4,
                  }}
                  aria-label="Sélectionnez la première date"
                  onChange={(e) => handleDateChange(e)}
                  value={selectedDate || ""}>
                  <option value="">Sélectionner une date</option>
                  {testDates
                    ?.sort((a, b) => new Date(b) - new Date(a))
                    .map((testDate, index) => (
                      <option key={index} value={testDate}>
                        {new Date(testDate).toLocaleDateString("fr-FR")}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              {!showPeriod2 ? (
                <Col md={4} style={{ marginBottom: 0, display: 'flex', alignItems: 'flex-end' }}>
                  <div 
                    onClick={() => setShowPeriod2(true)}
                    style={{
                      cursor: 'pointer',
                      color: '#1976d2',
                      fontWeight: 'bold',
                      padding: '20px 0',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <i className="fas fa-chart-line" style={{ marginRight: '8px' }}></i>
                    Comparer avec un autre questionnaire
                  </div>
                </Col>
              ) : (
                <Col md={4} style={{ marginBottom: 20 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Form.Label style={{ color: "#1976d2" }}>autres questionnaire</Form.Label>
                    <div 
                      onClick={() => {
                        setShowPeriod2(false);
                        setDate2(null);
                      }}
                      style={{
                        cursor: 'pointer',
                        color: '#dc3545',
                        fontSize: '16px'
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </div>
                  </div>
                  <Form.Select
                    style={{
                      height: 42,
                      borderColor: "#1976d2",
                      color: "#1976d2",
                      borderWidth: 2,
                      borderRadius: 4,
                    }}
                    aria-label="Sélectionnez la deuxième date"
                    onChange={(e) => setDate2(e.target.value)}
                    value={date2 || ""}>
                    <option value="">Sélectionner une date</option>
                    {testDates
                      ?.sort((a, b) => new Date(b) - new Date(a))
                      .filter(d => d !== selectedDate)
                      .map((testDate, index) => (
                        <option key={index} value={testDate}>
                          {new Date(testDate).toLocaleDateString("fr-FR")}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
              )}
            </Row>
          )}
          {userInfos?.referentId && role === "admin" && (
            <Col md={12} style={{ marginBottom: 20 }}>
              <div style={{ color: "#ce9136" }}>
                Référent : {referentInfos?.firstName} {referentInfos?.lastName}
              </div>
            </Col>
          )}
         </Row>
        <Row>
          {!chartData || filteredTestData?.length === 0 ? (
            <Col md="12">
              <Card style={{ borderRadius: "4px" }}>
                {
                  (loading || loadingUser) ?  <Container
                  fluid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <span>Chargement...</span>
                </Container> :                 <Card.Body style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", minHeight: "200px" }}>
                  {role === "referent" ? (
                    <span>
                      {!requestSentDate && !requestSentDate
                        ? "Cliquez sur le bouton de déblocage ci-dessus pour que l'administrateur fasse parvenir le questionnaire à votre client."
                        : "Veuillez attendre que votre client complète le test et que l'administrateur vous fasse parvenir les résultats du questionnaire."}
                    </span>
                  ) : (
                     role === "candidate" ? <span>Vos résultats ne sont pas encore disponibles. Votre coach a été prévenu de la bonne fin de la passation du questionnaire. <br/> Il analysera les résultats avec vous et vous les transmettra après votre débriefing.</span>: "Le questionnaire a été débloqué. Les résultats seront visibles une fois que le candidat l'aura complété"
                  )}
                </Card.Body>
                }

              </Card>
            </Col>
          ) : (
            <Col md="12">
              <Card
                style={{
                  borderRadius: "4px",
                  overflow: "visible",
                  ...(isPrinting
                    ? {}
                    : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }),
                }}>
                <Card.Body style={{ position: "relative", overflow: "visible" }}>
                  {role === "candidate" && selectedDate && (
                    <div style={{ 
                      position: "absolute",
                      top: "20px",
                      left: "-200px",
                      textAlign: "left",
                      zIndex: 1000,
                      whiteSpace: "nowrap"
                    }}>
                      <h3 style={{ color: "#000", fontWeight:"bolder", margin: 0 }}>
                        Voici les résultats de votre test du {formatISODate(selectedDate)}
                      </h3>
                    </div>
                  )}
                  <div
                    style={{
                      position: "relative",
                      width: 924,
                      height: 1080,
                      paddingTop: 120,
                      ...(isPrinting ? {} : {}),
                    }}>
                    <div>
                      {chartData ? (
                        <>
                          <Chart
                            type="radar"
                            options={options}
                            data={
                              filteredTestData?.length > 0
                                ? chartData
                                : { labels: [], datasets: [] }
                            }
                          />
                          <RadarLabel
                            top="340px"
                            left="20px"
                            labelText="Vous-même"
                            colorText={"rgba(50, 226, 185,1)"}
                          />
                          <RadarLabel
                            top="130px"
                            left="320px"
                            labelText="Dans le futur"
                            colorText={"rgba(83, 109, 254, 1)"}
                          />
                          <RadarLabel
                            top="120px"
                            right="230px"
                            labelText="Vous aujourd'hui"
                            colorText={"rgba(150, 50, 226, 1)"}
                          />
                          <RadarLabel
                            top="300px"
                            right="-60px"
                            labelText="Vos valeurs"
                            colorText={"rgba(135, 0, 0, 1)"}
                          />
                          <RadarLabel
                            bottom="450px"
                            right="-120px"
                            labelText="Etat d'esprit"
                            colorText={"rgba(0, 38, 142, 1)"}
                          />
                          <RadarLabel
                            bottom="210px"
                            right="-90px"
                            labelText="Communication"
                            colorText={"rgba(226, 50, 50, 1)"}
                          />
                          <RadarLabel
                            bottom="300px"
                            left="30px"
                            labelText="Résilience"
                            colorText={"#35A047"}
                          />
                          <RadarLabel
                            bottom="50px"
                            right="150px"
                            labelText="Confiance"
                            colorText={"rgba(255, 140, 0, 1)"}
                          />
                          <RadarLabel
                            bottom="60px"
                            left="280px"
                            labelText="Conflit"
                            colorText={"#B46627"}
                          />
                        </>
                      ) : (
                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'center', 
                          alignItems: 'center', 
                          height: '600px', 
                          width: '100%' 
                        }}>
                          <Spinner animation="border" role="status" style={{ width: '5rem', height: '5rem' }}>
                            <span className="sr-only">Chargement...</span>
                          </Spinner>
                        </div>
                      )}
                    </div>
                  </div>
                </Card.Body>
                {role === "admin" && (
                  <div style={{ alignSelf: "stretch" }}>
                    <ActivityTimeline activities={activities} />
                  </div>
                )}
              </Card>
            </Col>
          )}
        </Row>

        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          style={{
            position: "absolute",
            top: 20,
            right: 20,
          }}
          bg={toastVariant}>
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </Container>
    </div>
  );
});

const Dashboard = () => {
  const componentRef = useRef();
  const [isPrinting, setIsPrinting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setIsPrinting(true);
      setIsLoading(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          setIsLoading(false);
          resolve();
        }, 1300); // Réduit à 1300 ms
      });
    },
    onAfterPrint: () => {
      setIsPrinting(false);
    },
  });

  return (
    <div>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}>
          <Spinner animation="border" variant="light" />
        </div>
      )}
      <DashboardForward
        ref={componentRef}
        handlePrint={handlePrint}
        isPrinting={isPrinting}
      />
    </div>
  );
};

export default Dashboard;
